export default {
  'meta': {
    'langName': 'CZECH',
    'lang': 'Čeština'
  },
  'title': 'Stažení výrobku z prodeje Elektrická koloběžka SD500E nebo MD500E značky BTWIN',
  'description': 'Dobrý den,\r\n\r\nzakoupili jste si elektrickou koloběžku SD 500E nebo MD500E značky BTWIN a my Vám za to děkujeme.\r\n\r\nVaše bezpečnost je naší prioritou, proto se prosím seznamte s následujícími informacemi.\r\n\r\nI přes přísné postupy kontroly kvality jsme zjistili, že elektrické koloběžky SD500E a MD500E značky BTWIN vykazují bezpečnostní vadu. Intenzivní používání může vést ke vzniku praskliny v místě spoje mezi rámem a představcem (tyčí) řídítek. Tato vada může způsobit prasknutí tohoto spoje, což pro uživatele představuje riziko pádu.\r\n\r\nProsíme Vás o zodpovězení následujících otázek, abychom Vám mohli poskytnout řešení pro zajištění bezpečnosti Vašeho výrobku.\r\n\r\nOmlouváme se za způsobené nepříjemnosti a děkujeme Vám za důvěru.\r\n\r\nDECATHLON',
  'emailConfirmation': {
    'title': 'Nejprve prosím potvrďte svou emailovou adresu a zemi vašeho bydliště'
  },
  'fields': {
    'country': 'Země',
    'address': 'E-mail ',
    'email': 'E-mail ',
    'phonePrefix': 'Telefoní předvolba',
    'phone': 'Telefoní číslo',
    'validations': {
      'phoneOrEmail': 'Uveďte prosím alespoň emailovou adresu nebo telefoní číslo',
      'email': 'Zadejte prosím platnou emailovou adresu',
      'phone': 'Zadejte prosím platné telefoní číslo',
      'selectAddress': 'Vyberte prosím ze seznamu úplnou adresu (číslo popisné, ulice a město).',
      'incompleteAddress': 'Adresa musí obsahovat číslo popisné, název ulice a město. Zadejte alespoň číslo popisné a název ulice a poté vyberte návrh.'
    },
    'firstName': 'Příjmení',
    'lastName': 'Jméno',
    'deliveryAddress': 'Adresa pro doručení balíčku',
    'additionalAddress': 'Další podrobnosti o adrese',
    'city': 'Město',
    'zip': 'PSČ',
    'readConfirmation': 'Ověřil(a) jsem si své kontaktní údaje, přečetl(a) jsem si informace a souhlasím s nimi.',
    'choose': 'Vybrat',
    'required': 'Toto pole je povinné',
    'deliveryAddressHelp': 'Zadejte číslo popisné a název ulice a poté vyberte ze seznamu úplnou adresu.',
    'streetOnlyHint': 'Přidat číslo popisné'
  },
  'ownerCheck': {
    'title': 'Jste stále majitelem jedné nebo více elektrických koloběžek BTWIN SD500E a MD500E?'
  },
  'yes': 'ANO',
  'no': 'NE',
  'ownerChanged': {
    'title': 'Máte kontakt na součastného majitele/majitelku?',
    'confirmation': 'Pane/Paní\n\nDěkujeme za vaši účast v této iniciativě za kvalitu a bezpečnost.\n\nOmlouváme se za nepříjemnost a děkujeme za vaši důvěru\n\nDECATHLON'
  },
  'recall': {
    'title': 'Prosím, uveďte množství elektrických koloběžek BTWIN SD500E a MD500E.',
    'descriptionSd500': 'Elektrické koloběžky SD500E',
    'descriptionEmd500e': 'Elektrické koloběžky MD500E',
    'modelNumberHelp': 'Číslo modelu (SD500E nebo MD500E) najdete na spodní straně koloběžky, jak je zde znázorněno.',
    'quantity': 'Počet',
    'confirmation': 'Děkujeme za vyplnění tohoto formuláře, vaše žádost byla úspěšně zaregistrována. Do 20 dnů vás budeme informovat o datu, od kterého můžete opravu provést.  Přejeme hezký den. DECATHLON'
  },
  'repair': {
    'title': 'Oprava s vaší účastí',
    'description': 'Žádáme Vás, abyste ji již dále nepoužívali.\n\nDomů Vám bude zaslána opravná sada a návod, abyste si mohli koloběžku sami zabezpečit. Tato sada Vám bude zaslána zdarma a její montáž je snadná a rychlá.\n\n\nPo shromáždění Vašich údajů vás budeme do 20 dnů kontaktovat s informací o datu, od kterého bude opravná sada k dispozici. Ujišťujeme vás, že vynaložíme veškeré úsilí, abychom tuto lhůtu zkrátili a zajistili vaši spokojenost.',
    'videoLink': 'Odkaz pro video',
    'store': 'Odkaz pro návod',
    'kitLabel': 'Kompletní sada na opravu',
    'docLabel': 'Pokyny k opravě',
    'callToAction': 'Klikněte zde a získejte opravnou sadu zdarma',
    'infoConfirmation': 'Zkontrolujte prosím své informace',
    'validateConfirmation': 'Potvrdit',
    'backConfirmation': 'Zpět'
  },
  'repairRequest': {
    'title': 'Pro obdržení opravné sady zadejte prosím následující informace.'
  },
  'form': {
    'submit': 'Další'
  },
  'status': 'Translation validated by COUNTRY'
} as const
